import { LINK_TO_HEADLINER } from 'utils/constants';

export const LINK_TO_MAKE_PROJECTS_PAGE = `${LINK_TO_HEADLINER}/projects`;
